import React from 'react'
import { useAccessInfo } from '../contexts/AccessTokenProvider';
import { Securables } from '../Enums';

export interface OnlyForRoleProps {
    role: Securables,
    preventOverrides?: boolean,
    children?: React.ReactChild | React.ReactChild[] | (() => React.ReactChild);
}
const OnlyForRole = ({ role, preventOverrides = false, children }: OnlyForRoleProps) => {
    const { hasRole } = useAccessInfo();
    let fetcher =  children instanceof Function ? (children as Function) : (() => children);
    if (hasRole(role, preventOverrides))
        return <>{fetcher()}</>;
    else
        return null;
};


export default OnlyForRole;